import { APIClient } from "@/utils/httpClient";
import { APIError } from "@/errors";
import { Action } from "@/types/action";

export const getAction = async (campaignId: string, actionID: string) => {
    const response = await APIClient.get(`/campaigns/${campaignId}/actions/${actionID}`);
    if (response.success) {
        return response.data as Action;
    } else {
        throw new APIError(response.message);
    }
};